import * as React from 'react';
import { LabelButton, ModalContainer } from '@teamsnap/snap-ui';
import { experimentUtils } from 'core/experiments';
import TSPlusLogo from '../../assets/images/teamsnap-plus/5-light.png';
import { useAmplitude } from 'state/hooks/useAmplitude';

export const EXPERIMENT_NAME = 'teamsnap-plus-offer-reg2';
const VARIANT_NAME = 'treatment';

export const PaintedDoor = () => {
  const [open, setOpen] = React.useState(false);
  const { amplitudeTrack } = useAmplitude();

  const isExperimentEnabled =
    experimentUtils.isExperimentEnabled(EXPERIMENT_NAME, VARIANT_NAME) ||
    experimentUtils.isExperimentEnabledForTesting(EXPERIMENT_NAME, VARIANT_NAME);

  React.useEffect(() => {
    if (isExperimentEnabled) {
      amplitudeTrack.tsUpsellViewed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExperimentEnabled]);

  if (!isExperimentEnabled) {
    return null;
  }

  return (
    <>
      <div id={EXPERIMENT_NAME} className="sui-py-2 sui-body sui-border-b sui-border-solid sui-border-b-gray-5">
        <img src={TSPlusLogo} alt="TeamSnap+" className="sui-mb-1" style={{ width: '150px', height: 'auto'}} />
        <div className="sui-heading-sm">Supercharge your season!</div>
        <p>
          With a TeamSnap+ subscription you get sport-specific drills from top coaches, 1:1 training for practice at
          home, & an ad-free mobile app experience.
        </p>
        <LabelButton
          labelText="Try FREE for 7 days"
          variantType="primary"
          size="small"
          className="sui-mt-2"
          data-testid="painted-door-button"
          onClick={() => {
            amplitudeTrack.tsUpsellClicked();
            setOpen(true);
          }}
        />
      </div>
      <ModalContainer isOpen={open} onClose={() => setOpen(false)}>
        <div className="sui-px-2 sui-pt-4 sui-pb-1 sui-flex-grow" data-testid="painted-door-modal">
          <div className="sui-heading-sm sui-mb-2">Coming soon!</div>
          <p>
            We're working hard to bring this subscription to life. To unlock TeamSnap+ today, download the TeamSnap
            mobile app and click "Subscribe."
          </p>
        </div>
      </ModalContainer>
    </>
  );
};
